import { COMPANY } from "@/data/content";
import { Download, ExternalLink, FileText } from "lucide-react";

const ALLEGATI = [
  {
    id: "mup",
    title: "MUP — Modello Unico Precontrattuale",
    desc: "Contratti rami Danni, RC Auto e Vita.",
    file: "/mup-danni-vita.pdf",
  },
  {
    id: "provvigioni",
    title: "Provvigioni RC Auto",
    desc: "Provvigioni percepite per i contratti RC Auto.",
    file: "/provvigioni-rca.pdf",
  },
  {
    id: "elenco",
    title: "Elenco delle imprese",
    desc: "Elenco delle imprese con le quali collabora l'intermediario.",
    file: "/elenco-imprese.pdf",
  },
];

export default function InformazioniIntermediario() {
  return (
    <div data-testid="page-informazioni-intermediario" className="pt-28 pb-32">
      <section className="container-x py-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">Trasparenza IVASS</span>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] tracking-tight">
            Informazioni <span className="italic text-primary">intermediario</span>
          </h1>
          <p className="mt-4 text-primary font-medium">Obblighi informativi a carico degli Intermediari</p>
        </div>
      </section>

      <section className="container-x grid md:grid-cols-12 gap-16">
        <div className="md:col-span-8 md:col-start-3 space-y-6 text-lg text-muted-foreground leading-relaxed">
          <p>
            Il Regolamento IVASS (Istituto per la Vigilanza sulle Assicurazioni) n. 40/2018 contiene disposizioni in
            materia di distribuzione assicurativa e riassicurativa (applicabile dal 1° ottobre 2018) di cui al Titolo IX
            (Disposizioni generali in materia di distribuzione) del Decreto Legislativo n. 205 del 7/09/2005 (Codice
            delle Assicurazioni Private).
          </p>
          <p>
            Fra gli aspetti più significativi di tale regolamento sono trattati gli obblighi informativi a cui è tenuta
            una società di brokeraggio assicurativo: in particolare l'obbligo di consegna dell'elenco delle imprese con
            cui il broker ha (o potrebbe avere) rapporti d'affari. Tale adempimento può essere assolto anche attraverso
            la pubblicazione di queste informazioni sul sito internet dell'intermediario o tramite l'affissione di tale
            elenco nei propri locali.
          </p>
          <p className="text-foreground">Di seguito sono riportate tali informative:</p>
        </div>
      </section>

      <section className="container-x mt-16 grid md:grid-cols-3 gap-6">
        {ALLEGATI.map((a) => (
          <a
            key={a.id}
            href={a.file}
            target="_blank"
            rel="noreferrer"
            data-testid={`allegato-${a.id}`}
            className="group border border-foreground/10 hover:border-primary/50 bg-background p-8 sm:p-10 transition-colors flex flex-col justify-between min-h-[280px]"
          >
            <FileText className="h-8 w-8 text-primary" />
            <div className="mt-8">
              <p className="font-display text-2xl leading-tight">{a.title}</p>
              <p className="mt-2 text-sm text-muted-foreground">{a.desc}</p>
            </div>
            <span className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-primary underline-link">
              <Download className="h-4 w-4" /> Scarica PDF
            </span>
          </a>
        ))}
      </section>

      <section className="container-x mt-24">
        <div className="border-t border-foreground/10 pt-10 grid md:grid-cols-12 gap-8 text-sm text-muted-foreground">
          <div className="md:col-span-4">
            <p className="overline">Iscrizione RUI</p>
            <p className="mt-3">
              Sezione B — n.{" "}
              <a href={COMPANY.ruiUrl} target="_blank" rel="noreferrer" className="text-primary underline-link inline-flex items-center gap-1">
                {COMPANY.rui} <ExternalLink className="h-3 w-3" />
              </a>
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="overline">Vigilanza</p>
            <p className="mt-3">IVASS — Istituto per la Vigilanza sulle Assicurazioni</p>
          </div>
          <div className="md:col-span-4">
            <p className="overline">P.IVA</p>
            <p className="mt-3">{COMPANY.vat}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
